// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"47f13490","316":"ed9b867c","670":"36bf91bf","859":"f803ef6d","933":"0aa1e61f"}[chunkId] + ".chunk.js";
};